class StickyAtc extends HTMLElement {
  connectedCallback() {
    const sectionId = this.dataset.productSection;
    this.productSection = document.getElementById(sectionId);
    if (!this.productSection) return;

    this.footer = document.querySelector('footer') || document.querySelector('[id*="footer"]');

    this.productObserver = new IntersectionObserver(
      ([entry]) => {
        this.productOutOfView = !entry.isIntersecting;
        this.update();
      },
      { threshold: 0 }
    );

    this.productObserver.observe(this.productSection);

    if (this.footer) {
      this.footerObserver = new IntersectionObserver(
        ([entry]) => {
          this.footerInView = entry.isIntersecting;
          this.update();
        },
        { threshold: 0 }
      );
      this.footerObserver.observe(this.footer);
    }

    this.querySelector('.sticky-atc__button').addEventListener('click', () => {
      this.productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  disconnectedCallback() {
    this.productObserver?.disconnect();
    this.footerObserver?.disconnect();
  }

  update() {
    const show = this.productOutOfView && !this.footerInView;
    this.classList.toggle('is-visible', show);
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}
